export default [
    {
        path: 'entrega-exame',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-entrega-exame' */
            '@/views/exame-laboratorial/entrega-exame/Index'
        ),
        redirect: 'entrega-exame/create',
        children: [
            {
                name: 'exame-laboratorial-entrega-exame-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-entrega-exame' */
                    '@/views/exame-laboratorial/entrega-exame/Form.vue'
                ),
            },
        ],
    }
]